module.exports = __webpack_public_path__ + "static/media/chat.ca67fc2d.png";